import React, { FC, ReactNode } from "react";
import classNames from "classnames/dedupe";
import {
  IMediaBuilderProps,
  MediaBuilder,
  SvgIconType,
} from "../../Utility/MediaBuilder";

export interface IBrandLogoProps {
  /** Icon media data (image or svg, params: src or name of icon, etc.) */
  iconData?: IMediaBuilderProps;
  customImage?: JSX.Element;
  children?: ReactNode;
}

const BrandLogo: FC<IBrandLogoProps> = ({
  iconData,
  customImage,
  children,
}) => (
  <div
    className={classNames("product-brand-logo text-color-black", {
      "product-brand-logo--mode-img": (
        [undefined, "image"] as Array<IMediaBuilderProps["type"]>
      ).includes(iconData?.type),
      "product-brand-logo--mode-svg-sprite": iconData?.type === "svg-sprite",
    })}
  >
    {customImage || (
      <MediaBuilder
        {...iconData}
        type={iconData.type as any}
        data={
          iconData.type === "svg-icon"
            ? ({
                preserveAspectRatio: "xMinYMin meet",
                ...iconData.data,
              } as SvgIconType["data"])
            : (iconData.data as any)
        }
      />
    )}

    {children}
  </div>
);

export default BrandLogo;
